var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-container',{attrs:{"vertical-center":""}},[_c('base-popup',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('standard-button',_vm._g({attrs:{"type":"tertiary","label":"申請時の情報を確認する","running":_vm.running}},on))]}}])},[_c('base-text-preformatted',{staticClass:"pa-4",attrs:{"value":_vm.requestedInfo}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }